import React, { useEffect, useState } from "react";

import { Button, Img, Input, Text } from "components";

import { CloseSVG } from "../../assets/images";
import { cartChanges, totalItemsInCarts } from "../../states/cart.mjs";
import { Link, useNavigate } from "react-router-dom";
import { addSearchKeyword, searchKeywordChanges } from "../../states/search.mjs";

const HaierLogo = require("../../assets/images/haier_logo.png");

const Header = (props) => {
  const [searchinputvalue, setSearchinputvalue] = React.useState("");
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const subscription = cartChanges(() => {
      setTotalItems(totalItemsInCarts());
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    const subscription = searchKeywordChanges((value) => {
      setSearchinputvalue(value);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <>
      <header style={{ background: "black" }} className={props.className + " sticky top-0 z-20 shadow"}>
        <div
          className={`flex flex-row items-center  ${props?.showSearch === true ? "" : "sm:justify-center"} px-4 py-2 w-full`}>
          <div onClick={() => {
            navigate("/");
          }} className="flex sm:hidden flex-col items-start justify-start mr-2 cursor-pointer">
            <Img style={{maxWidth: 80 }} src={HaierLogo} />
          </div>
          <Link style={{marginLeft:16, marginRight: 16}} to={'/'}
                className="flex flex-col items-start justify-start mr-2 cursor-pointer">
            <Button>
              <Text className={"text-white-A700"}>Home</Text>
            </Button>
          </Link>

          <Link style={{marginLeft:16, marginRight: 16}} to={"/productspage"}>
            <Button>
              <Text className={"text-white-A700"}>Products</Text>
            </Button>
          </Link>
          <div className="sm:flex flex-grow" />
          {
            (props?.showSearch ?? true) &&
            <div className={'sm:hidden'} style={{ maxWidth: 700, marginLeft: 24, marginRight: 24, width: "100%" }}>
              <Input
                name="searchinput"
                placeholder="Search"
                value={searchinputvalue}
                onChange={(e) => {
                  addSearchKeyword(e);
                  setSearchinputvalue(e);
                }}
                className="!placeholder:text-blue_gray-900 !text-blue_gray-900 text-base font-inter p-0 text-left tracking-[0.50px] w-full"
                wrapClassName="flex mb-[11px] mt-4 mr-2 w-full"
                prefix={
                  <Img
                    className="cursor-pointer h-3.5 mr-5 my-px"
                    src="images/img_search.svg"
                    alt="search"
                  />
                }
                suffix={
                  <CloseSVG
                    fillColor="#ffffff"
                    className="cursor-pointer h-3.5 my-auto"
                    onClick={() => {
                      addSearchKeyword("");
                      setSearchinputvalue("");
                    }}
                    style={{
                      visibility:
                        searchinputvalue?.length <= 0 ? "hidden" : "visible"
                    }}
                    height={14}
                    width={14}
                    viewBox="0 0 14 14"
                  />
                }
                shape="round"
                color="white_A700"
                size="sm"
                variant="fill"
              />
            </div>
          }
          {/*<div className="sm:flex flex-grow" />*/}
          <div
            className="flex flex-row gap-3 items-center">
            {/*<div onClick={() => {*/}
            {/*  navigate("/ordersviewpage");*/}
            {/*}} className="flex flex-col cursor-pointer items-center justify-center">*/}
            {/*  <Img*/}
            {/*    className="h-[36px] w-[36px]"*/}
            {/*    src="images/img_personoutline.svg"*/}
            {/*    alt="personoutline"*/}
            {/*  />*/}
            {/*  <Text*/}
            {/*    className="text-white-A700 text-xs tracking-[0.40px] whitespace-nowrap"*/}
            {/*    size="txtInterRegular12Gray90001"*/}
            {/*  >*/}
            {/*    My Orders*/}
            {/*  </Text>*/}
            {/*</div>*/}
            <div
              onClick={() => {
                navigate("/cartreviewpage");
              }}
              className="cursor-pointer flex flex-col justify-center items-center">
              <Img
                className="h-[36px] w-[36px]"
                src="images/img_shoppingcart.svg"
                alt="shoppingcart"
              />
              <Text
                className="text-white-A700 text-xs tracking-[0.40px] whitespace-nowrap"
                size="txtInterRegular12Gray90001"
              >
                Items ( {totalItems} )
              </Text>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

Header.defaultProps = {
  className: "flex bg-white-A700 md:flex-col flex-row md:gap-10 items-center justify-between w-full",
  showSearch: true
};

export default Header;
